import { render, staticRenderFns } from "./CopyTreeToIndicator.vue?vue&type=template&id=6ac8af40&scoped=true&"
import script from "./CopyTreeToIndicator.vue?vue&type=script&lang=js&"
export * from "./CopyTreeToIndicator.vue?vue&type=script&lang=js&"
import style0 from "./CopyTreeToIndicator.vue?vue&type=style&index=0&id=6ac8af40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac8af40",
  null
  
)

export default component.exports